import React from "react";
import TextareaAutosize from "react-textarea-autosize";

const Multiline = props => {
  return <TextareaAutosize {...props} />;
};

export default Multiline;
